import React, { useEffect, useState } from "react";

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 400);
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll, {
            passive: true,
        });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <button
            type="button"
            onClick={scrollToTop}
            aria-label="Scroll to top"
            className={` group fixed bottom-6 right-6 z-[90] flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-[#8B1E3F] text-white shadow-[0_12px_35px_rgba(7,26,47,0.22)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#071A2F] hover:shadow-[0_16px_40px_rgba(7,26,47,0.3)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D5AD57] focus-visible:ring-offset-2 ${isVisible ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
                className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5"
            >
                <path
                    d="M6 15L12 9L18 15"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
}